// @flow

import { EmptyContent } from "../../../components/EmptyContent";
import { Row } from "antd";
import { SkeletonLine } from "../../../components/Loaders/SkeletonLine";
import { pathOr } from "ramda";
import LineCard from "../../../components/common/LineCard";
import LineFolder from "../../../components/common/LineFolder";
import OfficeDesktopLayout from "views/components/OfficeDesktopLayout";
import Provider from "views/components/OfficeDetail";
import React from "reactn";
import styled from "styled-components";

/*
type OfficeDetailProps {|
	loading: boolean,
	folder: string,
	folders: Array<string>,
|};
*/

const OfficeDetail = ({
	user,
	loading,
	office,
	lines,
	folders,
	folder,
	navToFolder,
}) => {
	let noBoxLines = lines.filter((off) => off.type !== "box");
	const show_box_lines = pathOr(false, ["options", "show_box_lines"], office);
	const checkIsDisabled = (office) => {
		return office && office.options.administrativeDeactivation;
	};

	return (
		<OfficeDesktopLayout
			user={user}
			office={office}
			title={!!lines.length && "Selecciona un trámite y únete a la fila"}
		>
			{checkIsDisabled(office) && (
				<h4
					style={{
						textAlign: "center",
						width: "100%",
						background: "#f0f0f0",
					}}
				>
					Sucursal no disponible
				</h4>
			)}
			<LinesWrapper gutter={[16, 32]} style={{ marginBottom: "18px" }}>
				{!folder &&
					folders.map((folder) => (
						<LineFolder
							key={folder}
							name={folder}
							categoryName={folder}
							officeSlug={office && office.slug}
							onClick={navToFolder(folder)}
							isDisabled={checkIsDisabled(office)}
						/>
					))}
				{folder && <FolderName>{folder}</FolderName>}
				{show_box_lines
					? lines.map((line) => (
							<LineCard
								key={line.id}
								office={office}
								line={line}
								officeSlug={office && office.slug}
								isDisabled={checkIsDisabled(office)}
							/>
					  ))
					: noBoxLines.map((line) => (
							<LineCard
								key={line.id}
								office={office}
								line={line}
								officeSlug={office && office.slug}
								isDisabled={checkIsDisabled(office)}
							/>
					  ))}

				{loading &&
					!lines.length &&
					loading.length > 0 &&
					[(0, 1)].map((_, i) => (
						<SkeletonLine
							style={{ margin: 12 }}
							key={i}
						></SkeletonLine>
					))}
				{!loading && !lines.length && !folders?.length && (
					<WrapperEmpty>
						<EmptyContent description="Esta oficina no tiene filas..."></EmptyContent>
					</WrapperEmpty>
				)}
			</LinesWrapper>
		</OfficeDesktopLayout>
	);
};

/* const LinesWrapper = styled(Row)`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	width: 100%;
	padding: 8px 32px 0;
`; */

const LinesWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	margin-right: 10px;
	margin-left: 10px;
	/* justify-content: center; */
	width: 100%;
`;

const WrapperEmpty = styled.div`
	flex: 0 1 auto;
	flex-grow: 1;
`;

const FolderName = styled.h3`
	color: #096dd9;
	margin: 0;
	text-align: left;
	width: 100%;
	padding-left: 24px;
	margin-bottom: -8px;
`;

const BackButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 5px 16px;
	height: 32px;
	background: #ffffff;
	border: 1px solid #d9d9d9;
	box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);
	border-radius: 2px;
	&:hover {
		cursor: pointer;
		border: 1px solid #9ac2ff;
	}
`;

export default Provider(OfficeDetail);
